<template>
	<div class="px-2 pt-2 pb-3 space-y-1 sm:px-3">
		<span v-for="item in items" :key="item.label">
			<page-link
				:absolute="true"
				v-if="!item.children"
				:href="item.href"
				:class="
					isActive(item)
						? 'bg-green-700 text-white block px-3 py-2 rounded-md text-base font-medium'
						: 'text-white hover:bg-green-500 hover:bg-opacity-75 block px-3 py-2 rounded-md text-base font-medium'
				"
			>
				{{ __(item.label) }}
			</page-link>
			<ui-submenu
				v-else
				button-class="group w-full flex justify-between items-center text-white hover:bg-green-500 hover:bg-opacity-75 block px-3 py-2 rounded-md text-base font-medium"
			>
				<template v-slot:button>
					<span>{{ __(item.label) }}</span>
				</template>
				<template v-slot:items>
					<page-link
						v-for="child in item.children"
						:class="[
							'group w-full flex items-center pl-11 pr-2 py-2 text-sm font-medium text-green-300 rounded-md hover:text-green-100 hover:bg-green-500',
							isActive(child)
								? 'bg-gray-100'
								: 'hover:bg-green-500 hover:bg-opacity-75',
						]"
						:key="child.label"
						:href="child.href"
						:absolute="true"
						>{{ __(child.label) }}</page-link
					>
				</template>
			</ui-submenu>
		</span>
	</div>
</template>

<script>
import LayoutAdminTopNavItems from "./AdminTopNavItems.vue";
export default {
	mixins: [LayoutAdminTopNavItems],
};
</script>
